// MUST be the first import of index.tsx — sets webpack's runtime public path
// before any lazy chunk is requested.
//
// The build is served two ways: at a domain root (custom domains,
// {app}.dineplatform.com) AND behind a path prefix (www/demo.dineplatform.com
// /r/{appId}/*, via the dynamic-proxy-router worker). Chunk URLs are baked
// absolute (/static/...), which the router 404s on the prefixed hosts — so
// lazy routes (admin, live orders) failed to load there. Deriving the prefix
// from the browser URL makes chunk requests /r/{appId}/static/... when
// proxied and /static/... everywhere else.
/* eslint-disable no-undef, camelcase, @typescript-eslint/no-unused-vars */
declare let __webpack_public_path__: string;

const brandBase = window.location.pathname.match(/^\/r\/[^/]+/);
__webpack_public_path__ = brandBase ? `${brandBase[0]}/` : "/";

export {};
